module.exports = __webpack_public_path__ + "static/img/rank_homepage_avatar2.dab4c03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank/rank_homepage_avatar2.png
// module id = Y2s5
// module chunks = 0